<template>
    <div>
        <div class="table-header row">
            <div>
                状态
            </div>
            <div>
                网吧名称/网吧ID
            </div>
            <div>
                所在分组
            </div>
            <div>
                计算机名/服务器标签
            </div>
            <div>IP</div>
            <div>上次远程时间</div>
            <div>在线时长</div>
            <div>操作</div>
        </div>
        <div class="table-body">
            <div class="row" v-for="(item, index) in serverList" :key="index">
                <!-- 选中 -->
                <div>
                    <div v-if="remotingFlagArr.indexOf(item.flag) == -1">
                        <!-- 主服务器在线 -->
                        <img v-show="item.type==1&&item.isOnline==1"
                        src=@/assets/img/icon/zhu_server_online.png />
                        <!-- 主服务器离线 -->
                        <img v-show="item.type==1&&item.isOnline==0"
                        src=@/assets/img/icon/zhu_server_offline.png />
                        <!-- 副服务器在线 -->
                        <img v-show="item.type==0&&item.isOnline==1"
                        src=@/assets/img/icon/fu_server_online.png />
                        <!-- 副服务器离线 -->
                        <img v-show="item.type==0&&item.isOnline==0"
                        src=@/assets/img/icon/fu_server_offline.png />
                    </div>
                    <div v-if="remotingFlagArr.indexOf(item.flag) > -1">
                        <!-- 远程中服务器 -->
                        <img src=@/assets/img/icon/server_remoting.png />
                    </div>
                </div>
                <!-- 网吧名以及id -->
                <div class="bar-name">
                    <p v-text="item.barName"></p>
                    <p v-text="item.barId"></p>
                </div>
                <!-- 网吧分组名 -->
                <div>
                    <span v-text="item.groupName"></span>
                </div>
                <!-- 计算机名/服务器标签 -->
                <div class="computer-name">
                    <div class="one-line">
                        <server-tag-hover-down :tag="item">
                            <div slot="hoverBtn">
                                <div>
                                    <p
                                        v-text="
                                            $PropFn.safeDislayValue(
                                                item.computerName
                                            )
                                        "
                                    ></p>
                                </div>
                            </div>
                        </server-tag-hover-down>
                    </div>
                    <p v-text="item.serverTag" style="margin-top:-18px"></p>
                </div>
                <!-- IP -->
                <div class="ip-name">
                    <p>
                        <span class="gray-color">(外)</span>
                        <span v-text="item.wanIp"></span>
                    </p>
                    <p>
                        <span class="gray-color">(内)</span>
                        <span v-text="item.localIp"></span>
                    </p>
                </div>
                <!-- 上次远程时间 -->
                <div class="last-time">
                    <p>
                        <span
                            v-text="showDate('Y-M-D', item.remoteTime)"
                        ></span>
                    </p>
                    <p>
                        <span
                            v-text="showDate('h:m:s', item.remoteTime)"
                        ></span>
                    </p>
                </div>
                <!-- 在线时长 -->
                <div>
                    <span
                        v-text="
                            onlineTimeSubtract(item.onlineTime, item.isOnline)
                        "
                    ></span>
                </div>
                <div class="operate">
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.transferRemote(item, 1, 0)
                        "
                        >远程控制</a
                    >
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.transferRemote(item, 1, 1)
                        "
                        >观看模式</a
                    >
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.remoteCmd(
                                {
                                    barId: item.barId,
                                    flag: item.flag,
                                    local: item.localIp,
                                    name: item.barName,
                                    isOnline: item.isOnline,
                                    computerName: item.computerName
                                },
                                1
                            )
                        "
                        >远程命令</a
                    >
                    <word-down class="more-btn" :content="'更多'">
                        <div slot="down">
                            <!-- <div class=drop-row>
                                <span>使用Radmin连接</span>
                            </div>
                            <div class=drop-row>
                                <span>使用3389连接</span>
                            </div>
                            <i class=line></i> -->
                            <div class="drop-row" @click="restartServe(item)">
                                <span>重启产品服务</span>
                            </div>
                            <i class="line"></i>
                            <!-- <div class=drop-row
                                @click="sendRemoteCommand(item,1,10002)">
                                <span>删除服务器</span>
                            </div> -->
                            <div
                                class="drop-row"
                                @click="sendRemote('关闭', item, 1, 10001)"
                            >
                                <span>关闭服务器</span>
                            </div>
                            <div
                                class="drop-row"
                                @click="sendRemote('重启', item, 1, 10002)"
                            >
                                <span>重启服务器</span>
                            </div>
                            <i class="line"></i>
                            <div
                                class="drop-row"
                                @click="setServerAutoLogin(item)"
                            >
                                <span>设置服务器自动登录</span>
                            </div>
                        </div>
                    </word-down>
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                v-show="serverList.length == 0 || loading"
                :nodata="serverList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
    </div>
</template>

<script>
// 更多悬浮
import WordDown from "_c/dropdown/wordDown";
import ServerTagHoverDown from "_sc/serverTagHoverDown";
import NoData from "_c/noData/noData";
import { mapGetters } from "vuex";
import { showDate } from "@/utils/time";
import { onlineTimeMinSec, onlineTimeSubtract } from "_slib/time";

import { sendRemoteCommand } from "@/requests/bar";
export default {
    name: "tableData",
    components: {
        WordDown,
        ServerTagHoverDown,
        NoData
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            serverList: []
        };
    },
    computed: {
        ...mapGetters({
            remotingFlagArr: "plugin/remotingFlagArr"
        })
    },
    watch: {
        tableList() {
            this.serverList = this.tableList;
        }
    },
    methods: {
        setServerAutoLogin(item) {
            window.$modal.setServerAutoLogin.show(item.barId, item.flag);
        },
        sendRemoteCommand,
        sendRemote(content, item, i, cmdid) {
            if (item.computerName == null) {
                item.computerName = " -- ";
            }
            window.$Message.show({
                title: "是否" + content,
                type: "success",
                msgLeft: "你确认",
                msgCenter: content,
                msg:
                    item.computerName + "(" + item.localIp + ")" + "服务器吗？",
                cancleBtn: true,
                confirmFn: () => {
                    this.sendRemoteCommand(item, i, cmdid);
                    window.$Message.hide();
                }
            });
        },
        restartServe(item) {
            window.$modal.restartServeModal.show(item);
        },
        showDate,
        onlineTimeMinSec,
        onlineTimeSubtract
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;
        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }
    .more-btn {
        margin-left: 0;
    }

    > div:nth-child(1) {
        width: 5%;
        text-indent: 10px;
        input {
            position: relative;
            top: 2px;
        }
    }
    > div:nth-child(2) {
        width: 11%;
    }
    > div:nth-child(3) {
        width: 9%;
    }
    > div:nth-child(4) {
        width: 16%;
    }
    > div:nth-child(5) {
        width: 14%;
    }
    > div:nth-child(6) {
        width: 10%;
    }
    > div:nth-child(7) {
        width: 10%;
    }
    > div:nth-child(8) {
        width: 25%;
    }
}

.table-header {
    > div {
        height: 30px;
        line-height: 30px;
    }
}

.bar-name,
.computer-name,
.ip-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.computer-name {
    p:nth-child(1) {
        margin-top: -20px;
        color: $blue-1;
    }
}

.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}
.gray-color {
    color: $gray-word;
}
.last-time {
    line-height: 15px;
    p:nth-child(1) {
        margin-top: 8px;
    }
    p:nth-child(2) {
        color: $gray-word;
    }
}
</style>
